export type Color = {
  name: string;
  color: string;
};

export const darkCornflowerBlue1: Color = {
  name: "Dark Cornflower Blue 1",
  color: "#3c78d8",
};

export const colors: Color[] = [
  {
    name: "Black",
    color: "#000000",
  },
  {
    name: "Dark Gray 4",
    color: "#434343",
  },
  {
    name: "Dark Gray 3",
    color: "#666666",
  },
  {
    name: "Dark Gray 2",
    color: "#999999",
  },
  {
    name: "Dark Gray 1",
    color: "#b7b7b7",
  },
  {
    name: "Gray",
    color: "#cccccc",
  },
  {
    name: "Light Gray 1",
    color: "#d9d9d9",
  },
  {
    name: "Light Gray 2",
    color: "#efefef",
  },
  {
    name: "Light Gray 3",
    color: "#f3f3f3",
  },
  {
    name: "White",
    color: "#ffffff",
  },
  {
    name: "Red Berry",
    color: "#980000",
  },
  {
    name: "Red",
    color: "#ff0000",
  },
  {
    name: "Orange",
    color: "#ff9900",
  },
  {
    name: "Yellow",
    color: "#ffff00",
  },
  {
    name: "Green",
    color: "#00ff00",
  },
  {
    name: "Cyan",
    color: "#00ffff",
  },
  {
    name: "Cornflower Blue",
    color: "#4a86e8",
  },
  {
    name: "Blue",
    color: "#0000ff",
  },
  {
    name: "Purple",
    color: "#9900ff",
  },
  {
    name: "Magenta",
    color: "#ff00ff",
  },
  {
    name: "Light Red Berry 3",
    color: "#e6b8af",
  },
  {
    name: "Light Red 3",
    color: "#f4cccc",
  },
  {
    name: "Light Orange 3",
    color: "#fce5cd",
  },
  {
    name: "Light Yellow 3",
    color: "#fff2cc",
  },
  {
    name: "Light Green 3",
    color: "#d9ead3",
  },
  {
    name: "Light Cyan 3",
    color: "#d0e0e3",
  },
  {
    name: "Light Cornflower Blue 3",
    color: "#c9daf8",
  },
  {
    name: "Light Blue 3",
    color: "#cfe2f3",
  },
  {
    name: "Light Purple 3",
    color: "#d9d2e9",
  },
  {
    name: "Light Magenta 3",
    color: "#ead1dc",
  },
  {
    name: "Light Red Berry 2",
    color: "#dd7e6b",
  },
  {
    name: "Light Red 2",
    color: "#ea9999",
  },
  {
    name: "Light Orange 2",
    color: "#f9cb9c",
  },
  {
    name: "Light Yellow 2",
    color: "#ffe599",
  },
  {
    name: "Light Green 2",
    color: "#b6d7a8",
  },
  {
    name: "Light Cyan 2",
    color: "#a2c4c9",
  },
  {
    name: "Light Cornflower Blue 2",
    color: "#a4c2f4",
  },
  {
    name: "Light Blue 2",
    color: "#9fc5e8",
  },
  {
    name: "Light Purple 2",
    color: "#b4a7d6",
  },
  {
    name: "Light Magenta 2",
    color: "#d5a6bd",
  },
  {
    name: "Light Red Berry 1",
    color: "#cc4125",
  },
  {
    name: "Light Red 1",
    color: "#e06666",
  },
  {
    name: "Light Orange 1",
    color: "#f6b26b",
  },
  {
    name: "Light Yellow 1",
    color: "#ffd966",
  },
  {
    name: "Light Green 1",
    color: "#93c47d",
  },
  {
    name: "Light Cyan 1",
    color: "#76a5af",
  },
  {
    name: "Light Cornflower Blue 1",
    color: "#6d9eeb",
  },
  {
    name: "Light Blue 1",
    color: "#6fa8dc",
  },
  {
    name: "Light Purple 1",
    color: "#8e7cc3",
  },
  {
    name: "Light Magenta 1",
    color: "#c27ba0",
  },
  {
    name: "Dark Red Berry 1",
    color: "#a61c00",
  },
  {
    name: "Dark Red 1",
    color: "#cc0000",
  },
  {
    name: "Dark Orange 1",
    color: "#e69138",
  },
  {
    name: "Dark Yellow 1",
    color: "#f1c232",
  },
  {
    name: "Dark Green 1",
    color: "#6aa84f",
  },
  {
    name: "Dark Cyan 1",
    color: "#45818e",
  },
  darkCornflowerBlue1,
  {
    name: "Dark Blue 1",
    color: "#3d85c6",
  },
  {
    name: "Dark Purple 1",
    color: "#674ea7",
  },
  {
    name: "Dark Magenta 1",
    color: "#a64d79",
  },
  {
    name: "Dark Red Berry 2",
    color: "#85200c",
  },
  {
    name: "Dark Red 2",
    color: "#990000",
  },
  {
    name: "Dark Orange 2",
    color: "#b45f06",
  },
  {
    name: "Dark Yellow 2",
    color: "#bf9000",
  },
  {
    name: "Dark Green 2",
    color: "#38761d",
  },
  {
    name: "Dark Cyan 2",
    color: "#134f5c",
  },
  {
    name: "Dark Cornflower Blue 2",
    color: "#1155cc",
  },
  {
    name: "Dark Blue 2",
    color: "#0b5394",
  },
  {
    name: "Dark Purple 2",
    color: "#351c75",
  },
  {
    name: "Dark Magenta 2",
    color: "#741b47",
  },
  {
    name: "Dark Red Berry 3",
    color: "#5b0f00",
  },
  {
    name: "Dark Red 3",
    color: "#660000",
  },
  {
    name: "Dark Orange 3",
    color: "#783f04",
  },
  {
    name: "Dark Yellow 3",
    color: "#7f6000",
  },
  {
    name: "Dark Green 3",
    color: "#274e13",
  },
  {
    name: "Dark Cyan 3",
    color: "#0c343d",
  },
  {
    name: "Dark Cornflower Blue 3",
    color: "#1c4587",
  },
  {
    name: "Dark Blue 3",
    color: "#073763",
  },
  {
    name: "Dark Purple 3",
    color: "#20124d",
  },
  {
    name: "Dark Magenta 3",
    color: "#4c1130",
  },
];
